<template>
  <div class="curve-points-filter">
    <div class="design flex-container flex-row">
      <el-checkbox v-model="designChecked" @change="val=>$emit('on-design-checked',val)">{{ designPropertyData.name }}</el-checkbox>
      <ul class="main flex-item flex-item-grow flex-container flex-wrap flex-row flex-verti-center">
        <li v-for="(item,index) in designPropertyData.values" :key="index" class="item">
          <span>{{ item.label }}：</span>
          <span class="item-value">{{ item.value }}</span>
        </li>
      </ul>
    </div>
    <div class="operating flex-container flex-row">
      <el-checkbox v-model="operatingChecked" class="o-checkbox" @change="val=>$emit('on-operating-checked',val)">{{ operatingData.name }}</el-checkbox>
      <div class="main flex-item flex-item-grow">
        <el-table style="width: 100%" :data="tableData" class="center-table" >
          <el-table-column 
            align="center"
            v-for="(c) in operatingData.tableColumns"
            :key="c.prop"
            :prop="c.prop"
            :label="c.label"
            :formatter="fmtValue"
         />
        </el-table>
        <div v-if="operatingData.rate" class="radios flex-container flex-row flex-verti-center">
          <el-radio v-model="speedRegulated" :label="false" :disabled="!operatingChecked" @input="controlSpeedReugulation">不调速</el-radio>
          <el-radio v-model="speedRegulated" :label="true" :disabled="!operatingChecked" @input="controlSpeedReugulation">
            调速
          </el-radio>
          <div class="control" v-show="speedRegulated">
            <el-input 
              class="percent-rate"
              v-model="percentRate" 
              :disabled="!operatingChecked"
              oninput="value = value.replace(/[^\d.]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace(/(\.\d+)\./g, '$1').replace(/^0+(\d)/g, '$1').replace(/(\d+\.[\d]{1}).*$/g,'$1')"
              @change="customizeSpeed">
              <template slot="append">%</template>
            </el-input>
            <el-button type="plain" icon="el-icon-refresh" class="refresh-button" :disabled="!operatingChecked" @click="resetSpeedReugulation">重置</el-button>
          </div>
        </div>
        <div v-if="showAirVolume&&airVolume" class="air-volume flex-container flex-row flex-verti-center">
          <span>单位风量耗功率（W/(m³/h)）：</span>
          <span class="value">{{ airVolume }}</span>
          <el-tooltip content="=设计全压/(3600*0.855*运行全压效率/100)" placement="right" effect="dark">
            <i class="icon-tishi gjw-iconfont gjw-icon-tishi" />
          </el-tooltip>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import utils from '@/core/utils'
export default {
  name: 'CurvePointsFilter',
  props: {
    designPropertyData: {
      type: Object,
      default() {
        return {}
      }
    },
    operatingData: {
      type: Object,
      default() {
        return {}
      }
    },
    airVolume: [Number, Object]
  },
  inject: ['speedType'],
  data() {
    return {
      designChecked: true,
      operatingChecked: true,
      speedRegulated: false,
      percentRate: null // 百分号前的数字-扩大了一百倍
    }
  },
  methods: {
    controlSpeedReugulation() {
      this.speedRegulated && this.$emit('track')
      this.onSpeedRegulated()
    },
    onSpeedRegulated() {
      if (this.speedRegulated) { this.percentRate = this.originPercentRate }
      this.$emit('on-speed-regulated', { rate: null, speedRegulated: this.speedRegulated })
    },
    customizeSpeed(val) {
      if (val <= 50) {
        this.percentRate = 50
      } else if (val >= 100) {
        this.percentRate = 100
      } else {
        this.percentRate = Number(val)
      }
      this.$emit('on-speed-regulated', { rate: this.percentRate, speedRegulated: this.speedRegulated })
    },
    resetSpeedReugulation() {
      if (this.percentRate !== this.originPercentRate) {
        this.onSpeedRegulated()
      }
    },
    fmtValue(row, col) {
      return this.$fmtValue(row[col.property], '-')
    }
  },
  
  computed: {
    showAirVolume() {
      const speedType = this.speedType()
      return speedType === 'SINGLE_SPEED'
    },
    tableData() {
      return this.speedRegulated ? this.operatingData.regulationTableData : this.operatingData.tableData
    },
    originPercentRate() {
      return utils.timesValue(this.operatingData.originRate, 100)
    }
  }
}
</script>
<style lang='less' scoped>
.curve-points-filter{
  padding: 10px 12px 0;
}
.design{
  margin-bottom: 8px;
  .item{
    color: #14141E;
    min-width: 200px;
    &:last-child{
      margin-right: 0;
    }
  }
}
.operating{
  padding-bottom: 16px;
  border-bottom: 1px solid @theme-border-color;
  overflow-x: hidden;
  .o-checkbox{
    height: 24px;
  }
}
.main{
  margin-left: 12px;
  width: 1px;
}

.radios{
  height: 28px;
  box-sizing: content-box;
  padding-top: 12px;
  /deep/.el-button--mini{
    padding: 7px 4px;
    margin-left: 12px;
    border: unset;
    &:hover{
      color: unset;
      background: #fff;
    }
    &:active,&:focus{
      color: unset;
      background: #fff;
    }
  }
  .control{
    display: inline-block;
  }
  .percent-rate{
    width: 80px;
    margin-left: -18px;
  }
}

.air-volume{
    padding-top: 10px;
    .value{
      margin-right: 4px;
    }
    .icon-tishi{
      color: #8892A0;
      transition: all 0.2s;
      &:hover{
        color: @theme-hover-color;
      }
    }
  }
</style>
